module.exports = "/assets/data/5e6e0e21d1f6fefbba7c3f59fab994b1-SK6.data.json";